import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import React from "react";
import { IStatCard } from "./interface/IStatCard";

const StatCard: React.FC<IStatCard> = ({
  title,
  value,
  trend,
  icon,
  iconContainerClassName,
  iconColorClassName,
}) => {
  return (
    <div className="w-full h-full bg-white rounded-lg shadow border border-gray-100 p-4 flex items-start gap-3">
      <div
        className={`flex items-center justify-center w-10 h-10 rounded-md ${
          iconContainerClassName || "bg-blue-50"
        } ${iconColorClassName || "text-blue-600"}`}
      >
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs text-gray-500 mb-1 truncate">{title}</div>
        <div className="text-lg font-semibold text-gray-900 truncate">
          {value}
        </div>
        {!!trend && (
          <div
            className={`mt-1 text-[11px] font-medium flex items-center gap-1 ${
              trend.direction === "up"
                ? "text-green-600"
                : trend.direction === "down"
                  ? "text-red-600"
                  : "text-black"
            }`}
          >
            {trend.direction === "up" ? (
              <ArrowUpOutlined />
            ) : trend.direction === "down" ? (
              <ArrowDownOutlined />
            ) : (
              <></>
            )}
            <span>{trend.text}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
